import ProgressReportHFv4 from './component';
import _routes from './routes';
import { BottomButtons as _BottomButtons } from './IndividualDevelopmentPlanDetailView';

export const routes = _routes;
export const BottomButtons = _BottomButtons;

export default ProgressReportHFv4;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/index.js